// import store from 'store';
import _store from 'store/next.ts';
// that'll need to be updated. store will eventually become the default. . .

export default () => {
  if (parent === window) {
    return _store as any;
  }

  if (parent.getStore) {
    return parent.getStore();
  }

  return _store;
};
